import { AutomationEventTypes } from '@tokeet-frontend/automations'

export const userBookingNotificationMessages = {
  [AutomationEventTypes.InquiryCreated]: {
    subject: 'New Inquiry Received – *|RENTAL:NAME|*',
    message: `
        Hi Team,

        An inquiry has been created for *|RENTAL:NAME|*. Here are the details:

        Inquiry Details:
        Guest Name: *|GUEST:NAME|*
        Requested Dates: *|INQUIRY:ARRIVE|* to *|INQUIRY:DEPART|*
        Guests: *|INQUIRY:ADULTS|* Adults, *|INQUIRY:CHILDREN|* Children

        Please review the inquiry and respond promptly to keep things moving smoothly.
      `,
  },
  [AutomationEventTypes.BookingConfirmed]: {
    subject: 'New Booking Confirmed – *|RENTAL:NAME|*',
    message: `
        Hi Team,

        A new booking has been confirmed for *|RENTAL:NAME|*. Below are the details:

        Booking Details:
        Guest Name: *|GUEST:NAME|*
        Check-in/Check-out: *|INQUIRY:ARRIVE|* to *|INQUIRY:DEPART|*
        Guests: *|INQUIRY:ADULTS|* Adults, *|INQUIRY:CHILDREN|* Children

        Please review the booking details and prepare accordingly.
      `,
  },
  [AutomationEventTypes.BookingCanceled]: {
    subject: 'Booking Cancelled – *|RENTAL:NAME|*',
    message: `
        Hi Team,

        A booking has been canceled for *|RENTAL:NAME|*. Below are the details:

        Booking Details:
        Guest Name: *|GUEST:NAME|*
        Check-in/Check-out: *|INQUIRY:ARRIVE|* to *|INQUIRY:DEPART|*
        Guests: *|INQUIRY:ADULTS|* Adults, *|INQUIRY:CHILDREN|* Children
        Cancellation Date: *|INQUIRY:CANCEL_DATE|*

        Please take any necessary actions!
      `,
  },
  [AutomationEventTypes.BookingDatesUpdated]: {
    subject: 'Booking Dates Updated – *|RENTAL:NAME|*',
    message: `
        Hi Team,

        The dates for a booking at *|RENTAL:NAME|* have been updated. Below are the details:

        Booking Details:
        Guest Name: *|GUEST:NAME|*
        New Check-in Date: *|INQUIRY:ARRIVE|*
        New Check-out Date: *|INQUIRY:DEPART|*

        Please take any necessary actions!
      `,
  },
  [AutomationEventTypes.BookingRentalUpdated]: {
    subject: 'Booking Rental Updated – *|RENTAL:NAME|*',
    message: `
        Hi Team,

        The rental for a booking at *|RENTAL:NAME|* has been updated. Below are the details:

        Booking Details:
        Guest Name: *|GUEST:NAME|*
        New Rental: *|RENTAL:NAME|*
        Check-in Date: *|INQUIRY:ARRIVE|*
        Check-out Date: *|INQUIRY:DEPART|*

        Please review and take any necessary actions.
      `,
  },
  [AutomationEventTypes.BookingGuestUpdated]: {
    subject: 'Booking Guest Updated – *|RENTAL:NAME|*',
    message: `
        Hi Team,

        The guest for the booking at *|RENTAL:NAME|* has been updated. Below are the details:

        Booking Details:
        New Guest Name: *|GUEST:NAME|*
        Check-in Date: *|INQUIRY:ARRIVE|*
        Check-out Date: *|INQUIRY:DEPART|*

        Please review and update the booking as needed.
      `,
  },
  [AutomationEventTypes.BookingIsPaid]: {
    subject: 'Payment Received – *|RENTAL:NAME|*',
    message: `
        Hi Team,

        Booking Details:
        Guest Name: *|GUEST:NAME|*
        Check-in Date: *|INQUIRY:ARRIVE|*
        Check-out Date: *|INQUIRY:DEPART|*
        Amount Paid: *|INQUIRY:COST|*
        Please take any necessary needed actions.
      `,
  },
  [AutomationEventTypes.TimeBeforeBookingCheckIn]: {
    subject: 'Prepare Property for Arrival – *|GUEST:NAME|* at *|RENTAL:NAME|*',
    message: `
        Hi Team,

        Please be advised that the following booking requires preparation for the guest’s arrival:

        Booking Details:
        Guest Name: *|GUEST:NAME|*
        Check-in Date: *|INQUIRY:ARRIVE|*
        Check-out Date: *|INQUIRY:DEPART|*
        Guests: *|INQUIRY:ADULTS|* Adults, *|INQUIRY:CHILDREN|* Children

        Please ensure the property is ready for the guest’s arrival, including:
        - Cleaning and inspection;
        - Special requests or instructions;
        - Any amenities or services that need preparation.
      `,
  },
  [AutomationEventTypes.TimeAfterBookingCheckIn]: {
    subject: 'Guest Successfully Checked In – *|GUEST:NAME|* at *|RENTAL:NAME|*',
    message: `
        Hi Team,

        The guest has successfully checked in for the following booking:

        Booking Details:
        Guest Name: *|GUEST:NAME|*
        Check-in Date: *|INQUIRY:ARRIVE|*
        Check-out Date: *|INQUIRY:DEPART|*
        Guests: *|INQUIRY:ADULTS|* Adults, *|INQUIRY:CHILDREN|* Children

        Please ensure everything is prepared and running smoothly for their stay.
      `,
  },
  [AutomationEventTypes.TimeBeforeBookingCheckout]: {
    subject: 'Prepare for Guest Departure – *|GUEST:NAME|* at *|RENTAL:NAME|*',
    message: `
        Hi Team,

        Please be reminded that the following booking is approaching the guest's departure:

        Booking Details:

        Guest Name: *|GUEST:NAME|*
        Check-in Date: *|INQUIRY:ARRIVE|*
        Check-out Date: *|INQUIRY:DEPART|*
        Guests: *|INQUIRY:ADULTS|* Adults, *|INQUIRY:CHILDREN|* Children

        Please prepare the property for the guest's departure, including:

        - Cleaning: Ensure the property is thoroughly cleaned.
        - Inspection: Check for any damages or missing items.
        - Restocking: Restock any items or supplies as needed.
      `,
  },
  [AutomationEventTypes.TimeAfterBookingCheckout]: {
    subject: 'Guest Checked Out – *|GUEST:NAME|* at *|RENTAL:NAME|*',
    message: `
        Hi Team,

        Please be informed that the guest has officially checked out.

        Booking Details:
        Guest Name: *|GUEST:NAME|*
        Check-out Date: *|INQUIRY:DEPART|*

        Please proceed with the necessary post-check-out actions, including:
        - Cleaning
        - Inspection
        - Restocking or any other relevant tasks
    `,
  },
}

export const guestBookingNotificationMessages = {
  [AutomationEventTypes.InquiryCreated]: {
    subject: 'Thank You for Your Inquiry – *|RENTAL:NAME|*',
    message: `
        Dear *|GUEST:NAME|*,

        Thank you for your interest in *|RENTAL:NAME|*! We’ve received your inquiry and are reviewing availability.

        Next steps:
        Confirmation: We’ll notify you shortly once your booking is confirmed;
        Questions or Preferences: If you have any special requests or questions, please reply to this email;
        Secure Your Spot: To finalize your booking more quickly, feel free to provide additional details or confirm your intent to proceed.

        We appreciate your patience and look forward to hosting you!
      `,
  },
  [AutomationEventTypes.BookingConfirmed]: {
    subject: 'Booking Confirmed – *|RENTAL:NAME|*',
    message: `
        Dear *|GUEST:NAME|*,

        Thank you for choosing *|RENTAL:NAME|*! We’re excited to host you and ensure your stay is both comfortable and memorable.

        Here are the details of your booking:
        Check-in Date: *|INQUIRY:ARRIVE|*
        Check-out Date: *|INQUIRY:DEPART|*
        Guests: *|INQUIRY:ADULTS|* Adults, *|INQUIRY:CHILDREN|* Children
        Property Address: *|RENTAL:ADDRESS|*, *|RENTAL:CITY|* *|RENTAL:STATE|*, *|RENTAL:ZIP|*

        For your convenience:
        Check-in time: *|INQUIRY:CHECK_IN|*
        Check-out time: *|INQUIRY:CHECK_OUT|*
        If you have any questions, special requests, or need assistance, please don’t hesitate to reach out at *|RENTAL:PHONE|*.

        We look forward to welcoming you!
      `,
  },
  [AutomationEventTypes.BookingCanceled]: {
    subject: 'Booking Cancellation – *|RENTAL:NAME|*',
    message: `
        Dear *|GUEST:NAME|*,

        We regret to inform you that your booking at *|RENTAL:NAME|* has been canceled.

        Booking Details:
        Check-in Date: *|INQUIRY:ARRIVE|*
        Check-out Date: *|INQUIRY:DEPART|*
        We sincerely apologize for any inconvenience this may cause. If you have any questions or need assistance with rebooking, please don't hesitate to reach out to us at *|RENTAL:PHONE|*. We're happy to assist you with finding alternative options.

        Thank you for your understanding.
      `,
  },
  [AutomationEventTypes.BookingDatesUpdated]: {
    subject: 'Booking Dates Updated – *|RENTAL:NAME|*',
    message: `
        Dear *|GUEST:NAME|*,

        We would like to inform you that the dates for your booking at *|RENTAL:NAME|* have been updated.

        Booking Details:
        New Check-in Date: *|INQUIRY:ARRIVE|*
        New Check-out Date: *|INQUIRY:DEPART|*

        We apologize for any inconvenience this change may cause. If you have any questions or need assistance with rebooking, please don’t hesitate to reach out to us at *|RENTAL:PHONE|*. We are happy to help with alternative options or further adjustments.

        Thank you for your understanding.
      `,
  },
  [AutomationEventTypes.BookingRentalUpdated]: {
    subject: 'Booking Rental Updated – *|RENTAL:NAME|*',
    message: `
        Dear *|GUEST:NAME|*,

        We would like to inform you that your booking at *|RENTAL:NAME|* has been updated to a different rental property.

        Booking Details:
        Check-in Date: *|INQUIRY:ARRIVE|*
        Check-out Date: *|INQUIRY:DEPART|*
        If you have any questions or need assistance with the update, please don’t hesitate to reach out to us at *|RENTAL:PHONE|*. We apologize for any inconvenience this may cause and are happy to assist you with any alternative options.

        Thank you for your understanding.
      `,
  },
  [AutomationEventTypes.BookingGuestUpdated]: {
    subject: 'Booking Guest Updated – *|RENTAL:NAME|*',
    message: `
        Dear *|GUEST:NAME|*,

        We are pleased to inform you that you are now the confirmed guest for the booking at *|RENTAL:NAME|*.

        Booking Details:
        Check-in Date: *|INQUIRY:ARRIVE|*
        Check-out Date: *|INQUIRY:DEPART|*

        If you have any questions or need assistance, please don’t hesitate to reach out to us at *|RENTAL:PHONE|*. We look forward to hosting you!

        Thank you for choosing *|RENTAL:NAME|*.
      `,
  },
  [AutomationEventTypes.BookingCostUpdated]: {
    subject: 'Booking Cost Updated – *|RENTAL:NAME|*',
    message: `
        Dear *|GUEST:NAME|*,

        We would like to inform you that the cost of your booking at *|RENTAL:NAME|* has been updated.

        Booking Details:
        Check-in Date: *|INQUIRY:ARRIVE|*
        Check-out Date: *|INQUIRY:DEPART|*
        Updated Cost: *|INQUIRY:COST|*

        If you have any questions regarding the updated cost or need further assistance, please don’t hesitate to reach out to us at *|RENTAL:PHONE|*. We apologize for any inconvenience and are happy to help.

        Thank you for your understanding.
      `,
  },
  [AutomationEventTypes.BookingIsPaid]: {
    subject: 'Payment Received – *|RENTAL:NAME|*',
    message: `
        Dear *|GUEST:NAME|*,

        We’re pleased to confirm that we have received your payment for your booking at *|RENTAL:NAME|*.

        Booking Details:
        Check-in Date: *|INQUIRY:ARRIVE|*
        Check-out Date: *|INQUIRY:DEPART|*
        Amount Paid: *|INQUIRY:COST|*
        If you have any questions or need further assistance, please don’t hesitate to reach out to us at *|RENTAL:PHONE|*.

        We look forward to hosting you!

        Thank you for your payment and for choosing *|RENTAL:NAME|*.
      `,
  },
  [AutomationEventTypes.TimeBeforeBookingCheckIn]: {
    subject: 'Your Upcoming Stay at *|RENTAL:NAME|* – Pre-Arrival Information',
    message: `
        Dear *|GUEST:NAME|*,

        We’re excited to welcome you to *|RENTAL:NAME|* soon! To help ensure a smooth arrival, here are a few important details:

        Booking Details:
        Check-in Date: *|INQUIRY:ARRIVE|*
        Check-out Date: *|INQUIRY:DEPART|*

        Arrival Instructions:
        Check-in Time: *|INQUIRY:CHECK_IN|*
        Address: *|RENTAL:ADDRESS|*, *|RENTAL:CITY|*, *|RENTAL:STATE|*, *|RENTAL:ZIP|*
        Parking Details: [Parking instructions, if any]
        Key Collection: [Self-check-in code, key location, or host details]

        Additional Information:
        [Special instructions, such as amenities, Wi-Fi details, or house rules]
        [Any services or upgrades the guest has opted for, like early check-in, special requests, etc.]

        If you have any questions or need assistance, feel free to reach out to us at *|RENTAL:PHONE|*. We look forward to hosting you!
      `,
  },
  [`${AutomationEventTypes.TimeBeforeBookingCheckIn}-send-guest-welcome`]: {
    subject: 'Your Upcoming Stay at *|RENTAL:NAME|* – We Can’t Wait to Host You!',
    message: `
        Dear *|GUEST:NAME|*,

        We’re excited to welcome you to *|RENTAL:NAME|* for your upcoming stay! Your check-in date is just around the corner, and we want to make sure everything is set for a smooth arrival.

        Here are a few quick details to help you prepare:
        Check-in Time: *|INQUIRY:CHECK_IN|*
        Address: *|RENTAL:ADDRESS|*, *|RENTAL:CITY|*, *|RENTAL:STATE|*, *|RENTAL:ZIP|*
        Check-in instructions: *|RENTAL:CHECKIN_INSTRUCTIONS|*
        Wi-Fi details: *|RENTAL:WIFI_NAME|*/*|RENTAL:WIFI|*

        If you have any special requests or need assistance during your stay, feel free to reach out to us. We're here to help!

        We hope you have a wonderful stay and enjoy everything our space and the surrounding area have to offer. Looking forward to hosting you!
        `,
  },
  [`${AutomationEventTypes.TimeBeforeBookingCheckIn}-send-guest-link`]: {
    subject: 'Access Your Guest Portal for *|RENTAL:NAME|*',
    message: `
        Dear *|GUEST:NAME|*,

        We hope you’re doing well and are looking forward to your upcoming stay at *|RENTAL:NAME|*! To make your experience as seamless as possible, we’ve created a personalized guest portal for you.

        You can access your guest portal by clicking the link below:
        *|INQUIRY:GUEST_PORTAL|*

        Should you need any assistance or have any questions, feel free to reach out to us. We're here to ensure you have a comfortable and enjoyable stay.

        We look forward to welcoming you to *|RENTAL:NAME|*!
      `,
  },
  [AutomationEventTypes.TimeAfterBookingCheckIn]: {
    subject: 'Welcome to *|RENTAL:NAME|* – Your Check-In Confirmation',
    message: `
        Dear *|GUEST:NAME|*,

        We’re thrilled to confirm that you’ve successfully checked in at *|RENTAL:NAME|*! We hope your journey was smooth and that you're now settled in comfortably.

        If you need anything during your stay—from additional amenities to local recommendations—please don’t hesitate to reach out. We’re here to ensure you have a wonderful experience!

        Check-in Details:
        Address: *|RENTAL:ADDRESS|*, *|RENTAL:CITY|*, *|RENTAL:STATE|*, *|RENTAL:ZIP|*
        Wi-Fi Code: *|RENTAL:WIFI|*
        House Rules: *|RENTAL:HOUSE_RULES|*

        Enjoy your stay, and please let us know if there’s anything we can do to assist you.
      `,
  },
  [AutomationEventTypes.TimeBeforeBookingCheckout]: {
    subject: 'Reminder: Check-out Details for Your Stay at *|RENTAL:NAME|*',
    message: `
        Dear *|GUEST:NAME|*,

        We hope you’ve had a wonderful stay at *|RENTAL:NAME|*! As your check-out time approaches, we’d like to remind you of a few important details:

        Check-out Time: *|INQUIRY:CHECK_OUT|*

        Check-out Procedures:
        Please leave the keys in [specified location].
        Kindly ensure all personal belongings are removed from the property.
        If you need any assistance or have any questions before check-out, don’t hesitate to reach out to us.

        Thank you for choosing *|RENTAL:NAME|*, and we wish you safe travels!
      `,
  },
  [AutomationEventTypes.TimeAfterBookingCheckout]: {
    subject: 'Thank You for Staying at *|RENTAL:NAME|* – We’d Love Your Feedback!',
    message: `
        Dear *|GUEST:NAME|*,

        Thank you for choosing to stay at *|RENTAL:NAME|*! We hope you had a comfortable and enjoyable experience. It was a pleasure having you, and we truly appreciate your trust in us.

        If you have a moment, we’d love to hear about your stay. Your feedback helps us improve and provides future guests with valuable insights. Please feel free to leave a review!

        Safe travels, and we hope to welcome you back in the future!
      `,
  },
}
